import { Box, Button, Typography, Divider } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

// import LiveBusesList from './LiveBusesList';
// import FrequencyInfo from './FrequencyInfo';
import ServiceLines from './ServiceLines';
import {
    getShapesByStopId, mapShapesToStops, getStopsByIds,
    getRelatedTripsByShapeIds, getRelatedRoutesByShapeIds,
     groupStopsByShapeIdWithTrips
} from '../../utils/stopUtil';
import { useAppState } from '../../context/AppStateProvider';
import { RouteInfoPanel } from './RouteInfoPanel';
import RouteMap from './RouteMap';

function StopInformationPanel({ stop, onClose, userLocation }) {

    const { stopTimes, trips, shapes, stops, routes, frequencies } = useAppState();
    if (!stop) return null;

    const relatedShapes = getShapesByStopId(stop.stop_id, stopTimes, trips, shapes);
    const shapeIds = relatedShapes.map(shape => shape.shape_id);

    const shapeToStopsMap = mapShapesToStops(trips, stopTimes, shapeIds);
    const allStopIds = new Set(Object.values(shapeToStopsMap).flat());

    const relatedStops = getStopsByIds(stops, allStopIds);
    const relatedTrips = getRelatedTripsByShapeIds(trips, shapeIds);

    const relatedRoutes = getRelatedRoutesByShapeIds(trips, routes, shapeIds);

    const groupedStopsByShape = groupStopsByShapeIdWithTrips(
        shapeToStopsMap, relatedStops, stopTimes, trips
    );

    console.log("relatedShapes", relatedShapes);
    console.log("shapeToStopsMap", shapeToStopsMap);
    console.log("relatedStops", relatedStops);
    console.log("relatedTrips", relatedTrips);
    console.log("relatedRoutes", relatedRoutes);
    console.log("groupedStopsByShape", groupedStopsByShape);

    const stopLat = parseFloat(stop.stop_lat);
    const stopLon = parseFloat(stop.stop_lon);

    // Example data, replace with real props/data fetching
    // const liveBuses = [
    //     { id: 'MB1234', eta: '5 min' },
    //     { id: 'MB4567', eta: '12 min' },
    // ];

    // const frequency = 'Every 10 mins from 6:00 AM to 11:00 PM';
    const serviceLines = ['BUS 101', 'BUS 204'];


    return (

        <Box
            sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                zIndex: 1500,
                bgcolor: 'background.paper',
                overflowY: 'auto',
                p: { xs: 2, sm: 4 },
                display: 'flex',
                flexDirection: 'column',
                gap: 3,
            }}
        >
            <Box display="flex" alignItems="center" mb={2} flexWrap="wrap" gap={1}>
                <Button
                    variant="outlined"
                    startIcon={<ArrowBackIcon />}
                    onClick={onClose}
                    sx={{ textTransform: 'none' }}
                >
                    Back
                </Button>

                <Typography variant="h5" fontWeight="bold" ml={2} noWrap>
                    {stop.stop_name}
                </Typography>
            </Box>

            <Divider sx={{ mb: 1 }} />

            {/* ✅ Wrap RouteMap in a Box and give it proper height */}
            <Box sx={{ minHeight: '60vh', flexShrink: 0, mb: -10 }}>
                <RouteMap
                    stopLat={stopLat}
                    stopLon={stopLon}
                    userLocation={userLocation}
                    shapes={relatedShapes}
                    stops={relatedStops}
                />
            </Box>

            {relatedRoutes.map((item, index) => (
                <RouteInfoPanel key={index} route={item}
                    stopsByShape={groupedStopsByShape} stop={stop} trips={trips} frequencies={frequencies} />
            ))}
            {/* 
            <Box my={3}>
                <LiveBusesList buses={liveBuses} />
            </Box>

            <Box my={3}>
                <FrequencyInfo frequency={frequency} />
            </Box> */}

            <ServiceLines lines={serviceLines} />
        </Box>


    );
}

export default StopInformationPanel;
